'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _FullScreenModal = require('../../../components/modal/FullScreenModal');

var _FullScreenModal2 = _interopRequireDefault(_FullScreenModal);

var _EmailUnsubscribe = require('./EmailUnsubscribe');

var _EmailUnsubscribe2 = _interopRequireDefault(_EmailUnsubscribe);

var _Icon = require('../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _navigationActions = require('../../../reducers/navigationActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var mapStateToProps = function mapStateToProps(state) {
    return {
        email: state.get('routing').locationBeforeTransitions.query.email,
        isGuest: state.getIn(['app', 'currentUser', 'isGuest'])
    };
};

// Actions
// Lib


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchNavigateToLogin: function dispatchNavigateToLogin() {
            return dispatch((0, _navigationActions.navigateToLogin)());
        },
        dispatchNavigateToRootWorkspace: function dispatchNavigateToRootWorkspace() {
            return dispatch((0, _navigationActions.navigateToRootWorkspace)());
        }
    };
};

var EmailUnsubscribeFullscreenModal = function EmailUnsubscribeFullscreenModal(props) {
    var isGuest = props.isGuest,
        dispatchNavigateToRootWorkspace = props.dispatchNavigateToRootWorkspace,
        dispatchNavigateToLogin = props.dispatchNavigateToLogin;

    var logoAction = isGuest ? dispatchNavigateToLogin : dispatchNavigateToRootWorkspace;

    return _react2.default.createElement(
        _FullScreenModal2.default,
        null,
        _react2.default.createElement(
            'div',
            { className: 'logo' },
            _react2.default.createElement(
                'span',
                { className: 'actionable', onClick: logoAction },
                _react2.default.createElement(_Icon2.default, { name: 'milanote-logo-large' })
            )
        ),
        _react2.default.createElement(_EmailUnsubscribe2.default, props)
    );
};

EmailUnsubscribeFullscreenModal.propTypes = {
    dispatchNavigateToLogin: _propTypes2.default.func,
    dispatchNavigateToRootWorkspace: _propTypes2.default.func,
    isGuest: _propTypes2.default.bool
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(EmailUnsubscribeFullscreenModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/EmailUnsubscribeFullscreenModal.js
// module id = 2083
// module chunks = 0